export const myUrl = process.env.VUE_APP_BACKEND_URL+process.env.VUE_APP_API_PATH;